/**
 * Convex URL Utility
 *
 * Centralized Convex URL configuration for different connection types
 * Uses environment variables with production fallbacks
 */

/**
 * Get the Convex WebSocket URL for queries and mutations
 *
 * @returns Convex WebSocket URL (e.g., https://energized-tiger-672.convex.cloud)
 *
 * Used by: ConvexProvider for real-time queries/mutations
 * Domain: .convex.cloud
 *
 * Priority:
 * 1. VITE_CONVEX_URL environment variable (set in .env.production or Netlify)
 * 2. Production fallback: energized-tiger-672.convex.cloud
 */
export function getConvexUrl(): string {
  return import.meta.env.VITE_CONVEX_URL || 'https://energized-tiger-672.convex.cloud';
}

/**
 * Get the Convex HTTP Actions URL for REST API endpoints
 *
 * @returns Convex HTTP Actions URL (e.g., https://energized-tiger-672.convex.site)
 *
 * Used by: HTTP fetch calls to /api/* endpoints
 * Domain: .convex.site (NOT .convex.cloud)
 *
 * CRITICAL: HTTP actions use .convex.site domain, not .convex.cloud!
 *
 * Priority:
 * 1. VITE_CONVEX_SITE_URL environment variable
 * 2. Production fallback: energized-tiger-672.convex.site
 */
export function getConvexHttpUrl(): string {
  return import.meta.env.VITE_CONVEX_SITE_URL || 'https://energized-tiger-672.convex.site';
}
